import React, {useRef} from 'react';
import * as Icon from 'ubs-icons';
import {bytesToSize} from "../common/function";
import {COLOR, FILE} from "../common/constant";
import UPopup from "ubs-framework/v2/UPopup";
import PropTypes from "prop-types";
import UPreviewPopup from "../UPreviewPopup";
import Popup from "reactjs-popup";

const UFileInfo = React.memo((props) => {
    const popupRef = useRef(null);

    const handle = {
        close: e => {
            if (popupRef?.current) popupRef?.current?.close();
        },
        download: file => {
            let iframe = document.createElement("iframe");
            iframe.style.visibility = "collapse";
            document.body.append(iframe);
            const url = props?._S3_BASE_URL + file.url;
            // eslint-disable-next-line
            iframe.contentDocument.write(`<form action="${url.replace(/\"/g, '"')}" method="GET"/>`);
            iframe.contentDocument.forms[0].submit();
            console.log('>>>>>>> ', url)
            setTimeout(() => iframe.remove(), 2000);
        }
    }

    return (
        <React.Fragment>
            <div className="u_file-info">
                <div className="u_file-info-icon">
                    <span className="u_m-auto u_text-center">
                        <Icon.FilePreview fill={COLOR.u_blue} size={18}/>
                        <span className="u_font">{props?.fileInfo?.ext}</span>
                    </span>
                </div>
                <div className="u_file-info-content">
                    <p className="u_file-name u_one-line u_mb-5">{props?.fileInfo?.fileName || '-'}</p>
                    <p className="u_small-font">{props?.fileInfo?.size ? bytesToSize(props?.fileInfo?.size) : 0}</p>
                </div>
                <div className="u_file-info-action">

                    {props?.action.includes('view') && (FILE.IMAGES.test(props?.fileInfo?.url)) ?
                        <Popup
                            ref={popupRef}
                            trigger={open => (
                                <div className="u_mx-5">
                                    <span className="u_cp">
                                        <Icon.Eye size={16} fill={COLOR.u_blue}/>
                                    </span>
                                </div>
                            )}
                            arrow={true}
                            on={['click']}
                            position="bottom center"
                            closeOnDocumentClick
                            repositionOnResize
                        >
                            <div className="u_block">
                                <UPreviewPopup
                                    src={props?._S3_BASE_URL + props?.fileInfo?.url}
                                    close={() => handle.close()}
                                />
                            </div>
                        </Popup> : (!FILE.ELSXFILES.test(props?.fileInfo?.url)) && <a href={props?._S3_BASE_URL + props?.fileInfo?.url} className=" u_lh-0" target="_blank" rel="noopener noreferrer">
                            <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>View</span>}>
                                <div className="u_cp u_mx-5">
                                    <Icon.Eye size={16} fill={COLOR.u_blue}/>
                                </div>
                            </UPopup>
                        </a>
                    }

                    {props?.action.includes('download') && <a href={props?._S3_BASE_URL + props?.fileInfo?.url} className=" u_lh-0" target="_blank" rel="noopener noreferrer">
                        <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>Download</span>}>
                            <div className="u_cp u_mx-5">
                                <Icon.Download size={16} fill={COLOR.u_blue}/>
                            </div>
                        </UPopup>
                    </a>}
                    {props?.action.includes('delete') &&
                    <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>Delete</span>}>
                        <div className="u_cp u_mx-5" onClick={() => props.handleDeleteFile()}>
                            <Icon.Delete size={16} fill={COLOR.u_blue}/>
                        </div>
                    </UPopup>}
                </div>
            </div>


        </React.Fragment>
    );
});

UFileInfo.propTypes = {
    action: PropTypes.array,
}
UFileInfo.defaultProps = {
    action: ['view', 'download'],
};

export default UFileInfo;
